export const REQUISITION_ROUTES = {
  list: '/staff/requisitions',
  new: '/staff/requisitions/new',
  detail: '/staff/requisitions/:id',
} as const;
